import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-add-phone',
  templateUrl: './add-phone.component.html',
  styleUrls: ['./add-phone.component.scss']
})
export class AddPhoneComponent implements OnChanges {

  @Input() display;
  @Input() header;
  @Input() isView;
  @Input() selectedProduct;
  @Output() closeModal = new EventEmitter();

  current1 = true;
  current2 = false;
  current3 = false;
  past1 = false;
  past2 = false;

  timezone = [];
  categories = [];
  prefix = [
    {id:1,name:"US +1",code:"US"},
    {id:2,name:"CN +86",code:"CN"},
  ];
  selectedPrefix = this.prefix[0];
  phoneNo;
  verifyType = 'msg';
  counter;
  isRepeatNo = false;
  tempProduct = {
    id:0,name:"",phone:"",category:{},timezone:{},isActive:true,isDefault:false,description:""
  }

  constructor(){
  }

  ngOnChanges(changes: SimpleChanges){
    if(this.selectedProduct){
      this.tempProduct = JSON.parse(JSON.stringify(this.selectedProduct));
    }
  }

  close(){
    this.closeModal.emit();
  }
  next1(){
    this.current1 = false;
    this.past1 = true;
    this.current2 = true;
  }
  back1(){
    this.current1 = true;
    this.past1 = false;
    this.current2 = false;
  }
  next2(){
    this.current2 = false;
    this.past2 = true;
    this.current3 = true;
    this.timer();
  }
  back2(){
    this.current2 = true;
    this.past2 = false;
    this.current3 = false;
  }
  next3(){

  }
  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  onCodeChanged(code: string) {
  }
  
  // this called only if user entered full code
  onCodeCompleted(code: string) {
  }

  timer() {
    let seconds: number = 60;
    let textSec: any = "0";
    let statSec: number = 60;

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.counter = `${textSec}`;

      if (seconds == 0) {
        clearInterval(timer);
      }
    }, 1000);
  }
  verifyNo(){
    console.log(this.phoneNo)

    if(this.phoneNo == "(111) 111-1111"){
      this.isRepeatNo = true;
    } else {
      this.isRepeatNo = false;
      this.next2();
    }
  }
}
